import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UserStatusesFetchFailedAction = {
	type: 'USER_STATUSES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UserStatusesFetchFailedAction => ({
	type: 'USER_STATUSES_FETCH_FAILED',
	payload,
});
